<div class="welcome-wizard-map-page-container container" fxLayout="row" fxLayoutGap="15px" [formGroup]="form">
  <div class="map-preferences-container container" fxFlex fxLayout="column">

    <!-- Map Default Mode Selection -->
    <p>{{ 'map_preferences.default_mode_description' | translate }}</p>
    <mat-radio-group formControlName="mapDefaultMode" fxLayout="column" fxLayoutGap="5px" color="primary" aria-label="Select Map Mode">
      <mat-radio-button [value]="MapMode.CLASSIC">{{ 'map_preferences.classic' | translate }}</mat-radio-button>
      <mat-radio-button [value]="MapMode.DARK">{{ 'map_preferences.dark' | translate }}</mat-radio-button>
    </mat-radio-group>

    <br/>

    <!-- Map Default Type Selection -->
    <p>{{ 'map_preferences.default_type_description' | translate }}</p>
    <mat-radio-group formControlName="mapDefaultType" fxLayout="column" fxLayoutGap="5px" color="primary" aria-label="Select Map Type">
      <mat-radio-button [value]="MapTypeId.ROADMAP">{{ 'map_preferences.road' | translate }}</mat-radio-button>
      <mat-radio-button [value]="MapTypeId.HYBRID">{{ 'map_preferences.satellite' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Example Map Preview -->
  <div>
    <p class="color-muted">{{ 'map_preferences.example' | translate }}</p>
    <div class="map-container container">
      <mtn-map [options]="mapOptions" *ngIf="mapOptions" (ready)="onMapReady($event)"></mtn-map>
    </div>
  </div>
</div>
